import cn from 'classnames'

export const getItemTextWithIconContainerThemeStyles = (
   theme: any,
   isSelected: boolean
): string => {
   const selectedBgColor = isSelected ? theme.selectedSalesPipelineBgColor : ''

   return cn(
      `${selectedBgColor} ${theme.customOptionHoverBgColor} flex items-center pl-8px py-10px pr-10px mx-6px my-2px rounded-10px outline-none cursor-pointer `
   )
}

export const getSalesPipelineCustomOptionThemeStyles = (
   color: string
): string => `${color} text-sm-medium flex-grow truncate max-w-[174px] mr-8px`

export const tickIconClassName = cn(`ml-auto`)
